import React from 'react';
import { FormGroup } from 'reactstrap';
import cn from 'classnames';
import styles from './Radio.module.css';

const BasicRadioBox = ({
    children,
    formGroupId,
    inputId,
    index,
    name,
    value,
    ariaLabel,
    onChange,
    checked,
    customClasses,
    error
}) => {
    const composedId = inputId + index ? `-${index}` : '';

    return (
        <FormGroup
            className={cn('no-gutters', styles.radioBoxWrapper, styles.group)}
            role='group'
            id={formGroupId}
        >
            <div
                className={styles.radioButton}
                role='radio'
                aria-checked={checked ? 'true' : 'false'}
                tabIndex='0'
            >
                <input
                    type='radio'
                    aria-label={ariaLabel}
                    name={name}
                    id={composedId}
                    value={value}
                    checked={checked}
                    onChange={onChange}
                />
                <label
                    id={composedId + '_label'}
                    className={cn('radio-controls-label', error && styles.formError, customClasses)}
                    for={composedId}
                >
                    {children}
                </label>
            </div>
        </FormGroup>
    );
};

export default BasicRadioBox;
